import { RightOutlined } from '@ant-design/icons';
import { ADMIN_BASE_BATH } from '@app/constants/variables';
import { Avatar } from 'antd';
import logo from 'assets/logo.jpg';
import { useResponsive } from 'hooks/useResponsive';
import React from 'react';
import * as S from './MainSider/MainSider.styles';

interface SiderLogoProps {
  isSiderCollapsed: boolean;
  toggleSider: () => void;
}
export const SiderLogo: React.FC<SiderLogoProps> = ({ isSiderCollapsed, toggleSider }) => {
  const { tabletOnly } = useResponsive();
  const companyName = process.env.REACT_APP_NAME || 'Company Name';
  const subName = process.env.REACT_APP_SUB_NAME || '';
  return (
    <S.SiderLogoDiv>
      <S.SiderLogoLink to={ADMIN_BASE_BATH}>
        <Avatar shape="circle" src={logo} alt="Company" size={48} />
        <S.Brand>
          <S.BrandSpan>{companyName}</S.BrandSpan>
          {subName && <S.BrandSpan>{subName}</S.BrandSpan>}
        </S.Brand>
      </S.SiderLogoLink>
      {tabletOnly && (
        <S.CollapseButton
          shape="circle"
          size="small"
          $isCollapsed={isSiderCollapsed}
          icon={<RightOutlined rotate={isSiderCollapsed ? 0 : 180} />}
          onClick={toggleSider}
        />
      )}
    </S.SiderLogoDiv>
  );
};
